export { WordsFrequencyView } from "#words-frequency-view";
